var _path, _mask, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.75V8.25M5.5 8.25L8.5 5.25M5.5 8.25L2.5 5.25",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4504_15907",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.75H11V9.75C11 10.8546 10.1046 11.75 9 11.75H2C0.895431 11.75 0 10.8546 0 9.75V7.75Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.75H11H0ZM12 9.75C12 11.4069 10.6569 12.75 9 12.75H2C0.343146 12.75 -1 11.4069 -1 9.75H1C1 10.3023 1.44772 10.75 2 10.75H9C9.55229 10.75 10 10.3023 10 9.75H12ZM2 12.75C0.343146 12.75 -1 11.4069 -1 9.75V7.75H1V9.75C1 10.3023 1.44772 10.75 2 10.75V12.75ZM12 7.75V9.75C12 11.4069 10.6569 12.75 9 12.75V10.75C9.55229 10.75 10 10.3023 10 9.75V7.75H12Z",
    fill: "#344054",
    mask: "url(#path-2-inside-1_4504_15907)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlack);
export default __webpack_public_path__ + "static/media/download-black.43f23970fb372caad690aaf7d63c829d.svg";
export { ForwardRef as ReactComponent };